import React from 'react';
import SubTitle from '../components/SubTitle'
// import Background from '../img/prodbg.jpg';

const Product = ({imgUrl}) => {
	return (
		<div className="product">
			<a href="#/"><img src={require("../img/prod.jpg")} alt=""></img><p>水系列阀门</p></a>
		</div>
	);
}

/*style={{'backgroundImage': `url(${Background})`}}*/
const Products = ({productLines}) => (
	<div className="block-content" style={{'backgroundColor': '#f8fcff'}}>	
		<div className="products">
			<SubTitle title="产品中心" subTitle="PRODUCTS" />
	      	<div className="products-items">
	      		{/*<div className="product">
					<a href="#/products/UNISTRUT"><img src={require("../img/UNISTRUT电缆桥架.jpg")} alt=""></img><p>电缆托架产品</p></a>
				</div>
				<div className="product">
					<a href="#/products/EMERSON"><img src={require("../img/APPLETON防爆电器.jpg")} alt=""></img><p>防爆灯具及电器产品</p></a>
				</div>
				<div className="product">
					<a href="#/products/Autocontrol"><img src={require("../img/AUTOCONTROL自动取样系统.jpg")} alt=""></img><p>自动取样设备</p></a>
				</div>
				<div className="product">
					<a href="#/products/LEONI"><img src={require("../img/LEONI仪表电缆.jpg")} alt=""></img><p>仪表及动力电缆</p></a>
				</div>
				<div className="product">
					<a href="#/products/LiquidControl"><img src={require("../img/LIQUID CONTROL罐区自动化.jpg")} alt=""></img><p>流量计及罐区自动化产品</p></a>
				</div>*/}
				{
					productLines.map((item, i) => {
                      	return(
                      		<div className="product" key={i}>
								<a href={`#/products/${item.ID}`}><img src={item.Image} alt=""></img><p>{item.Name}</p></a>
							</div>
                      	);
                    })
				}
	      	</div>
		</div>
	</div>
);

export default Products;


// WEBPACK FOOTER //
// ./src/components/Products.js